import { recurringTaskApi } from './recurringTaskApiBase';
import { RecurringTaskView, RecurringTasksListRequest } from './types';
import { TicketWorklistView } from '../TicketService';

export const recurringTaskQueriesApi = recurringTaskApi.injectEndpoints({
  endpoints: (builder) => ({
    getRecurringTasks: builder.query<RecurringTaskView[], RecurringTasksListRequest | void>({
      query: (params) => ({
        url: 'RecurringTasks',
        params: params || {},
      }),
      providesTags: ['RecurringTaskList'],
    }),

    getRecurringTaskById: builder.query<RecurringTaskView, string>({
      query: (id) => ({
        url: 'RecurringTask',
        params: { id },
      }),
      providesTags: (_result, _error, id) => [{ type: 'RecurringTask', id }],
    }),

    getGeneratedTickets: builder.query<TicketWorklistView[], string>({
      query: (id) => ({
        url: 'RecurringTask/GeneratedTickets',
        params: { id },
      }),
      providesTags: (_result, _error, id) => [{ type: 'RecurringTask', id }],
    }),
  }),
});

export const {
  useGetRecurringTasksQuery,
  useGetRecurringTaskByIdQuery,
  useGetGeneratedTicketsQuery,
} = recurringTaskQueriesApi;
